import {useDispatch, useSelector} from "react-redux"
import {useNavigate} from "react-router-dom"
import {actions as userActions} from "../global/slices/usersSlice"
import Button from 'react-bootstrap/Button';

export default function LogoutButton() {
  const nav = useNavigate()
  const dispatch = useDispatch()
  const {user} = useSelector(state => state.users)

  const logout = () => {
    dispatch(userActions.logout())
    nav("/login")
  }

  if (!user) return <></>

  return (
    <Button variant="success" onClick={logout}>Logout</Button>
  )
}
